import * as React from 'react';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import { compose } from 'redux';

import Dropdown from 'af-components/Controls/Dropdown';

import * as AccountActions from 'af-actions/accounts';

import styles from './styles.module.scss';

export interface OperatorFilterOption {
	id: number;
	label: string;
}

interface OwnProps {
	onChange: (option: Nullable<OperatorFilterOption>) => void;
}

type Props = OwnProps & ConnectedProps<typeof connector>;

const OperatorFilter: React.FC<Props> = (props) => {

	const {
		onChange,
		findAll,
	} = props;

	const [options, setOptions] = React.useState<OperatorFilterOption[]>([]);

	const fetchOptions = React.useCallback(async () => {
		const _options = await findAll();
		const formattedOptions = _options.users.map((option) => ({ id: option.id, label: option.fullName })).sort((a, b) => a.label.localeCompare(b.label));
		setOptions(formattedOptions);
	}, [findAll]);

	React.useEffect(() => {
		fetchOptions();
	}, [fetchOptions]);

	const renderOption = React.useCallback((option: OperatorFilterOption) => {
		return (
			<>
				{option.label}
			</>
		);
	}, []);

	const filterBy = React.useCallback((option: OperatorFilterOption, rawInput: string) => {
		return option.label.toLowerCase().includes(rawInput.toLowerCase());
	}, []);

	return (
		<div className={styles.dropdown}>
			<Dropdown<OperatorFilterOption>
				filterable={true}
				filterBy={filterBy}
				hasBlankOption={true}
				labelKey={'label'}
				onValueChange={onChange}
				options={options}
				placeholder="Select Operator"
				renderMenuItem={renderOption}
				valueKey={'id'}
				withCaret={true}
			/>
		</div>
	);
};

function mapDispatchToProps() {
	return {
		findAll: AccountActions.findAllForOrderReportOperatorFilter,
	};
}

const connector = connect(null, mapDispatchToProps());

const enhance = compose<React.ComponentType<OwnProps>>(
	React.memo,
	connector
);

export default enhance(OperatorFilter);
